<template>
  <div>

    <el-table :data="dt2table1" border class="tb-edit" style="width: 100%" ref="multipleTable" :header-cell-style="{'text-align':'center'}" row-key="id" :row-class-name="rowClassName" highlight-current-row>

      <el-table-column label="厂商" width="180" prop="cpasturename">
      </el-table-column>
      <el-table-column label="商务得分" width="110" prop="cbid">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.cbid"></el-input>
          <span>{{scope.row.cbid}}</span>
        </template>
      </el-table-column>
      <el-table-column label="技术得分" width="80" prop="cunit_price">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.cbid"></el-input>
          <span>{{scope.row.cbid}}</span>
        </template>
      </el-table-column>
      <el-table-column label="价格分" width="80" prop="ipricenum">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.cbid"></el-input>
          <span>{{scope.row.cbid}}</span>
        </template>
      </el-table-column>
      <el-table-column label="总得分" width="80" prop="ipricenum">
        <template slot-scope="scope">
          <span>{{scope.row.cbid}}</span>
        </template>
      </el-table-column>
      <el-table-column label="排名" width="80" prop="ipricenum">
      </el-table-column>
      <el-table-column label="是否预中标" width="80" prop="ipricenum">
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  props: {
    dt2table1: { type: Array },
  },
  name: "ruleTable",
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    //  报价详情
    rowClassName({ row, rowIndex }) {
      //把每一行的索引放进row.id
      row.id = rowIndex + 1;
    },
  },
};
</script>
<style scoped>
.tb-edit .el-input,
.tb-edit .el-select,
.tb-edit .el-textarea {
  display: none;
}
.tb-edit .current-row .el-input,
.tb-edit .current-row .el-select,
.tb-edit .current-row .el-textarea {
  display: block;
}
.tb-edit .current-row .el-input + span,
.tb-edit .current-row .el-select + span,
.tb-edit .current-row .el-textarea + span {
  display: none;
}
</style>
